const InputNumberField = ({
  labelName = "",
  name = "",
  register,
  id = "",
  type = "number",
  errors,
  errorText = "",
  placeholder = "",
  inputValue = "",
  isRequired = true,
  className = "",
  min = undefined,
  max = undefined,
  maxLength = undefined,
  disable = false,
  isReadOnly = false,
  onInput = () => {},
}) => {
  return (
    <>
      <label className="form-label title mb-2" htmlFor={id}>
        {labelName}{" "}
        {isRequired && !isReadOnly ? <span className="star">*</span> : null}
      </label>
      {isReadOnly ? (
        <input
          value={inputValue}
          type={type}
          className={`form-control w-75 ${className}`}
          disabled={true}
        />
      ) : (
        <>
          <input
            className={`form-control w-75 ${className}`}
            type={type}
            name={name}
            id={id}
            {...register(name, { required: isRequired, valueAsNumber: true })}
            placeholder={placeholder}
            min={min}
            max={max}
            maxLength={maxLength}
            disabled={disable}
            onInput={onInput}
          />
          {errors[name] && (
            <div className={`invalid-feedback d-block`}>{errorText}</div>
          )}
        </>
      )}
    </>
  );
};

export default InputNumberField;
